import React, { useState, useEffect } from "react";
import { Breadcrumb, Button, Input, Table, Modal, notification } from "antd";
import { callApi } from "../../api/apiCaller";
import routes from "../../api/routes";
import Loader from "../../components/loader/loader";
import { EditOutlined, DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import { GreenNotify, RedNotify } from "../../helper/helper";
import Blog from "../../components/updateBlog/updateBlog";
import { homeIcon } from "../../assets";

const Organizers = () => {
  const [yogaBlogs, setYogaBlogs] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [selectedBlog, setSelectedBlog] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);
  const [updateRecordData, setUpdateRecordData] = useState(null);
  const [isAddBlogModalVisible, setIsAddBlogModalVisible] = useState(false);
  const [contentDetails, setContentDetails] = useState("");

  const getAllBlogs = () => {
    callApi("GET", routes.getAllBlogs, null, setIsLoading, (res) => {
      console.log("RRRRRes", res);
      setYogaBlogs(res?.data?.blogs || []);
    });
  };

  useEffect(() => {
    getAllBlogs();
  }, []);

  const handleDelete = (recordId) => {
    callApi(
      "DELETE",
      `${routes.deleteBlog}/${recordId}`,
      null,
      setIsLoading,
      (res) => {
        if (res.status === 200) {
          setYogaBlogs((prevBlog) =>
            prevBlog.filter((blog) => blog._id !== recordId)
          );
          GreenNotify("Blog Deleted Successfully");
        } else {
          RedNotify("Error Occurred while deleting stage");
        }
      },
      (error) => {
        notification.error({
          message: "Error",
          description: "An error occurred while deleting the stage.",
        });
      }
    );
  };

  const handleAddYoga = () => {
    setUpdateRecordData(null);
    setIsAddBlogModalVisible(true);
  };

  const handleEditYoga = (recordId) => {
    const selectedBlog = yogaBlogs.find((blog) => blog._id === recordId);
    setUpdateRecordData(selectedBlog);
    setIsAddBlogModalVisible(true);
  };

  const handleShowContentDetails = (content) => {
    setContentDetails(content);
    setModalVisible(true);
  };

  const columns = [
    {
      title: "FaceYoga",
      dataIndex: "yogaTitle",
      className: "type-name-column-header",
      align: "center",
    },
    {
      title: "Title",
      dataIndex: "title",
      align: "center",
    },
    {
      title: "Content",
      dataIndex: "content",
      className: "type-name-column-header",
      align: "center",
      render: (text, record) => (
        <div>
          <Button
            type="link"
            onClick={() => handleShowContentDetails(record.content)}
          >
            See Content
          </Button>
        </div>
      ),
    },
    {
      title: "Image",
      dataIndex: "image",
      align: "center",
      render: (image) => (
        <div className="product-list-image">
          <img
            style={{
              width: 100,
              height: 100,
              borderRadius: 50,
              objectFit: "cover",
            }}
            src={image}
            alt="blog-image"
          />
        </div>
      ),
    },
    {
      title: "Action",
      dataIndex: "_id",
      className: "type-name-column-header",
      align: "center",
      render: (text, record) => (
        <div style={{ whiteSpace: "nowrap" }}>
          <Button
            type="primary"
            icon={<EditOutlined />}
            onClick={() => handleEditYoga(record._id)}
            style={{ marginRight: 8 }}
          ></Button>
          <Button
            type="danger"
            icon={<DeleteOutlined />}
            onClick={() => handleDelete(record._id)}
            style={{ marginRight: 8 }}
          ></Button>
        </div>
      ),
      width: "auto",
    },
  ];

  const data = yogaBlogs
    ?.map((item, index) => {
      return {
        key: index,
        _id: item?._id,
        title: item?.title,
        yogaTitle: item?.yogaTitle,
        image: item?.image,
        content: item?.content,
      };
    })
    .filter((item) => {
      const blogTitleMatch = item?.title
        ?.toLowerCase()
        .includes(searchText?.toLowerCase());
      const yogaTitleMatch = item?.yogaTitle
        ?.toLowerCase()
        .includes(searchText?.toLowerCase());
      return blogTitleMatch || yogaTitleMatch;
    });

  const getRowClassName = (record, index) =>
    index % 2 === 0 ? "server-role-even-row" : "server-role-odd-row";

  const handleCloseModal = () => {
    setModalVisible(false);
  };

  return (
    <div className="admin-products-main-container">
      <Loader loading={isLoading} />
      <Breadcrumb separator=">" className="bread-crumb">
        <div className="configure-server-home-icon">
          <img src={homeIcon} alt="home-icon" />
        </div>
        <Breadcrumb.Item>Home</Breadcrumb.Item>
        <Breadcrumb.Item>Blogs</Breadcrumb.Item>
      </Breadcrumb>
      <div className="configure-server-roles-main-heading-container">
        <h1>Blogs</h1>
        <div className="search-inputs" style={{ width: "30rem" }}>
          <Input
            placeholder="Search..."
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
          />
        </div>
      </div>
      <Button
        type="primary"
        icon={<PlusOutlined />}
        onClick={handleAddYoga}
        style={{ marginBottom: "16px" }}
      >
        Add Blog
      </Button>
      <div className="server-roles-tb-main-container">
        <Table
          rowClassName={getRowClassName}
          columns={columns}
          dataSource={data}
          pagination={true}
          className="subscriptionapi-table"
        />
      </div>

      <Blog
        visible={isAddBlogModalVisible}
        toggleModal={() => {
          setIsAddBlogModalVisible(false);
          getAllBlogs();
        }}
        recordData={updateRecordData}
      />

      <Modal
        title="Content Details"
        visible={modalVisible}
        onCancel={handleCloseModal}
        footer={[
          <Button key="close" onClick={handleCloseModal}>
            Close
          </Button>,
        ]}
      >
        <div>
          <div dangerouslySetInnerHTML={{ __html: contentDetails }} />
        </div>
      </Modal>
    </div>
  );
};

export default Organizers;
